import { jsx as t, jsxs as i } from "react/jsx-runtime";
import "react";
var H = (l) => /* @__PURE__ */ i("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-722 -796)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M4.45406 10L0 3.3158V16.6854L4.45406 10Z",
      fill: "black"
    }),
    /* @__PURE__ */ t("path", {
      d: "M6.29655 9.99999L0 0.548584V3.31581L4.45406 10L0 16.6854V19.4476L6.29655 9.99999Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ t("path", {
      d: "M19.9153 11.9566C19.9176 11.9308 19.9467 11.9051 20 11.8793V10V8.04344H19.9153H8.69538L3.3332 0H0V0.548594L6.29655 10L0 19.4476V20H3.3332L8.69538 11.9566H19.9153Z",
      fill: "#6DA544"
    }),
    /* @__PURE__ */ t("path", {
      d: "M19.6554 13.9131H9.23558L5.17773 20H19.9999V13.9131H19.6554Z",
      fill: "#0052B4"
    }),
    /* @__PURE__ */ t("path", {
      d: "M19.6554 6.08687H19.9999V0H5.17773L9.23558 6.08687H19.6554Z",
      fill: "#D80027"
    })
  ]
});
export {
  H as default
};
